module.exports = __webpack_public_path__ + "static/media/ed-robertson-616173-unsplash.7c72e417.jpg";